export enum Actions {
    SET_LEFTNAV = "SET_LEFTNAV"
}